import React from 'react';
import { PARTNERS_HOW_IT_WORKS_ID } from '../constants';
import PartnersCtaButton from '../components/PartnersCtaButton';
import PhoneMockup from '../components/PhoneMockup';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersHero: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <section className="container-chisme py-10 lg:py-28">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <p className="mb-4 inline-flex flex-wrap items-center gap-x-2 gap-y-1 rounded-full border border-[rgba(74,33,71,0.1)] bg-white px-4 py-1.5 font-jakarta text-xs font-semibold text-[#5a3158] sm:text-[13px]">
            {s.hero.badge.map((item, index) => (
              <React.Fragment key={item}>
                {index > 0 && (
                  <span className="text-[#5a3158]/30" aria-hidden>
                    ·
                  </span>
                )}
                <span>{item}</span>
              </React.Fragment>
            ))}
          </p>
          <h1 className="font-instrument text-[2.4rem] leading-[1.02] tracking-[-0.02em] text-[#2a0f2a] sm:text-5xl lg:text-[72px] lg:leading-[0.95] lg:tracking-[-0.025em]">
            <span className="block">
              {s.hero.h1Line1}
              <span className="lg:hidden"> {s.hero.h1Line2}</span>
            </span>
            <span className="hidden lg:block">{s.hero.h1Line2}</span>
            <span className="block italic text-chisme-primary">{s.hero.h1Accent}</span>
          </h1>
          <p className="mt-5 max-w-lg font-jakarta text-base leading-relaxed text-[#5a3158] lg:text-[17px] lg:leading-[25.5px]">
            {s.hero.subtitle}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <PartnersCtaButton>{s.cta.registerBusiness}</PartnersCtaButton>
            <PartnersCtaButton
              href={`#${PARTNERS_HOW_IT_WORKS_ID}`}
              variant="secondary"
              showArrow={false}
              external={false}
            >
              {s.cta.howItWorks}
            </PartnersCtaButton>
          </div>
        </div>

        <div className="flex justify-center lg:justify-end">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
};

export default PartnersHero;
